import api from "../api/api";
import { dispatch } from "../redux/redux-config";
import { showToast } from "../components/toast";
import navigate from "../utilities/navigation";
import { Path } from "../utilities/constants";

const parishSoftApis = {
  loadMessages: async function (payload, userId) {
    try {
      const result = await api.parishSoft.messageList(payload);
      if (result && result.success) {
        dispatch({
          type: "MESSAGES_LOADED",
          payload: {
            list: result?.alerts,
            totalCount: result?.totalCount,
            scheduledCount: result?.scheduledCount,
          },
        });
      }
      return result || { success: false, list: [], errorMessage: "No response from server." };
    } catch (error) {
      console.error("Error fetching messages:", error);
      return { success: false, list: [], errorMessage: "Error fetching messages." };
    }
  },

  textToSpeech: async (message) => {
    const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
    return await api.parishSoft.textToSpeech(parishSoftToken, message);
  },

  saveAlert: async (alert) => {
    const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";

    // If there's a recording, upload it before saving the Alert
    if (!alert.voiceFileIdentifier && alert.voiceRecording) {
      let uploadResult = await api.parishSoft.uploadRecording(
        parishSoftToken,
        alert.voiceRecording,
        alert.voiceRecording.type
      );
      if (uploadResult.success) alert.voiceFileUrl = uploadResult.url;
      else return;
    }

    dispatch("ALERT_SAVING", true);
    let result = await api.parishSoft.saveAlert(parishSoftToken, alert);
    dispatch("ALERT_SAVING", false);

    if (result?.success) {
      dispatch("RESET_MY_ALERTS");

      if (alert.isDraft) {
        showToast("success", "Your Draft has been saved.");
        navigate(Path.EmbedMessages);
      } else if (alert.scheduledDate || (alert.scheduledDates || []).length > 0) {
        showToast("success", "Message Scheduled");
        navigate(Path.EmbedMessages);
      } else {
        showToast("success", "Preparing Message.");
        navigate(Path.EmbedMessages);
      }
    }
  },

  bulkDelete: async (payload) => {
    return await api.parishSoft.bulkDelete(payload);
  },

  loadAlertDetails: async (alertId) => {
    dispatch("EMBED_NEW_ALERT", { ...blankAlert });
    try {
      const result = await api.parishSoft.getAlertDetails(alertId);
      if (result && result.success) {
        dispatch("EMBED_NEW_ALERT", result);
      }
    } catch (e) {
      // Optionally show error
    }
    navigate("/embeded-alert?id=" + alertId);
  },

  messagePreview: async (alertId) => {
    try {
      const result = await api.parishSoft.messagePreview(alertId);
      if (result && result.success) {
        dispatch("EMBED_NEW_ALERT", result);
      }
    } catch (e) {
      // Optionally show error
    }
  },

  loadPSEmailAndSenderNames: async function () {
    try {
      const result = await api.parishSoft.getEmailAndSenderNames();

      if (result.success) {
        return result.list || [];
      }
    }
    catch (error) {
      console.error("Error fetching email and sender names:", error);
      return [];
    }
  },

  saveFamilyMemberDetails: async (recipients) => {
    return await api.parishSoft.saveFamilyMemberDetails(recipients);
  },

  getAlertCredit: async () => {
    return await api.parishSoft.getAlertCredit();
  },

  getMessagePreviewVoiceRecipientList: async (request) => {
    return await api.parishSoft.getVoiceRecipients(request);
  },

  getMessagePreviewSmsRecipientList: async (request) => {
    return await api.parishSoft.getSmsRecipients(request);
  },

  getMessagePreviewEmailRecipientList: async (request) => {
    return await api.parishSoft.getEmailRecipients(request);
  },

};
export default parishSoftApis;

const initialState = {
  //   sync: {}, // Tracks sync/loading states
  messages: [], // List of messages
  totalCount: 0, // Total number of messages
  scheduledCount: 0,
  selectedMessage: null, // Message selected for bulk actions
  filters: [], // Filter options
};

export function messageReducer(state = initialState, action) {
  if (state === undefined) return initialState;
  switch (action.type) {
    case "MESSAGES_LOADED":
      return {
        ...state,
        messages: action.payload.list,
        totalCount: action.payload.totalCount,
        scheduledCount: action.payload.scheduledCount,
      };

    default:
      return state;
  }
}

const blankAlert = {
  name: "",
  isScheduled: false,
  subject: "",
  htmlMessage: "",
  allGroups: false,
  groups: [],
  isEmergency: false,
  attachments: [],
};
